import { useState } from "react";

import { PencilIcon } from "@heroicons/react/24/outline";

import { Button } from "../base/Button";
import Modal, { ModalControlProps } from "../../layouts/Modal";
import { ApplicationSettingsList } from "./ApplicationSettingsList";
import { useClipboardCopy } from "../../hooks/useClipboardCopy";

interface ApplicationSettingsConnectionStringModalProps
  extends ModalControlProps {
  connectionString?: string;
}

export function ApplicationSettingsConnectionStringModal({
  open,
  setOpen,
  connectionString,
}: ApplicationSettingsConnectionStringModalProps) {
  const { CopyToClipboardButton } = useClipboardCopy();

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Modal open={open} setOpen={handleClose} width="!w-2/3">
      <div>
        <div className="pl-4 pr-3.5 flex justify-between items-center border-b">
          <h2 className="text-lg font-stick font-medium leading-6 mb-4 text-gray-900">
            Application Settings Connection String
          </h2>
        </div>
        <div className="p-4 font-mono text-gray-800 break-all">
          {connectionString ? (
            <div className="flex space-x-4">
              <p className="flex-grow text-wrap break-all">
                {connectionString}
              </p>
              <CopyToClipboardButton copyText={connectionString} />
            </div>
          ) : (
            <span className="italic">{"<no-value>"}</span>
          )}
          <div></div>
        </div>
      </div>
    </Modal>
  );
}
